import { applyDecorators, HttpCode, HttpStatus, Post, UseInterceptors } from '@nestjs/common';
import {
  ApiForbiddenResponse,
  ApiInternalServerErrorResponse,
  ApiNoContentResponse,
  ApiNotFoundResponse,
  ApiUnauthorizedResponse,
  ApiUnprocessableEntityResponse,
} from '@nestjs/swagger';

import { Roles } from '../../auth';
import { AutoReapInterceptor } from '../interceptors';

export const DeleteResponse = (path: string | string[], roles?: string[]) =>
  applyDecorators(
    ApiForbiddenResponse({ description: 'Forbidden (403)' }),
    ApiInternalServerErrorResponse({ description: 'Internal Server Error (500)' }),
    ApiNoContentResponse({ description: 'No Content (204)' }),
    ApiNotFoundResponse({ description: 'Not Found (404)' }),
    ApiUnauthorizedResponse({ description: 'Unauthorized (401)' }),
    ApiUnprocessableEntityResponse({ description: 'Unprocessable Entity (422)' }),
    HttpCode(HttpStatus.NO_CONTENT),
    Post(path),
    Roles(roles),
    UseInterceptors(AutoReapInterceptor)
  );
